import React, { useState } from "react";

import { Col, FormLabel, Row } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { RestReportBean } from "../ds/client_ds.js";
import {
  CheckPaymentDetailsPaymentInquiryCriteriaBean,
  CheckPaymentHistoryPrintRequest,
  CreditMemoBean,
  CreditMemoSearchCriteria,
  CustomerSearchCriteria,
  RestCreditMemoBeanRequest,
  RestCustomerListRequest,
  RestPageListBean,
  RestReadRequest,
} from "../ds/ds.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import { PopupARModule, PopupInvoiceModule } from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { CreditMemoService } from "../services/CreditMemoService.js";
import { CustomerService } from "../services/CustomerService.js";
import { ReportService } from "../services/ReportService.js";
import CustomTable from "../gui_components/CustomTable.js";
import {
  AlertToolBox,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
  ColumnDefinition
} from "../gui_components/UIComponents.js";
import { CreditMemoLookupHandler } from "../lookup/CreditMemoLookupHandler";
class CreditMemoPaymentHistory extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "CreditMemo Payment History Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: true,
      isShowResetButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      summaryData: null,
      criteria: new CheckPaymentDetailsPaymentInquiryCriteriaBean(),
      criteriaViewShow: false,
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowInvoiceModule: false,
      isShowCustomerModule: false,
      isShowARModule: false,
      moduleForPopup: [],
      inquiryData: null,
      checkAppliedInvoiceList: [],
      creditMemoAppliedInvoiceList: [],
      creditMemoList: [],
      reversedCheckList: [],
      creditMemoData: null,
      showAutoCompleteList: true,
      customerPageListForAutoCompleteList: new Array(),
      showAutoCompleteCustomerList: true,
      creditPageListForAutoCompleteList: new Array(),
      showAutoCompleteCreditList: true,
      isDisableFields: false,
    };
    this.customerCodeRef = React.createRef();
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer"
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let creditMemoLookupHandler = new CreditMemoLookupHandler(
      this.companyCode,
      "creditMemo"
    );
    this.setState({ creditMemoLookupHandler: creditMemoLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  loadPage = (pageNumber) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    if (!isEmptyString(criteria.creditMemoNumber)) {
      this.loadCreditMemoPaymentInquiryList(criteria);
    } else {
      let errMsg = "Invalid Input Criteria..";
      let errorList = [];
      errorList.push(errMsg);
      this.setState({
        alertMessage: errorList,
        alertType: "danger",
        isShowAlert: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  loadCreditMemoPaymentInquiryList = (criteria) => {
    if (SecurityAccessManager.CreditMemoPaymentHistoryInquiry_IsAccessible()) {
      ReportService.inquireCheckPaymentHistoryReport(
        criteria,
        this.creditMemoPaymentInquiryPageResponse,
        this.errorCallBack
      );
    } else {
      this.inValidAccess(1);
    }
  };
  creditMemoPaymentInquiryPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let inquiryData = response.data.result.infoBean;
      let checkAppliedInvoiceList = [];
      let creditMemoAppliedInvoiceList = [];
      if (!isEmptyArray(response.data.result.checkAppliedInvoices)) {
        checkAppliedInvoiceList = response.data.result.checkAppliedInvoices;
        this.setState({
          isShowPDFButton: true,
          isShowExcelButton: true,
        });
      }
      if (!isEmptyArray(response.data.result.creditMemoAppliedInvoices)) {
        creditMemoAppliedInvoiceList =
          response.data.result.creditMemoAppliedInvoices;
      }
      let creditMemoData = new CreditMemoBean();
      if (response.data.result.creditMemoBean) {
        creditMemoData = response.data.result.creditMemoBean;
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: checkAppliedInvoiceList,
        creditMemoAppliedInvoiceList: creditMemoAppliedInvoiceList,
        inquiryData: inquiryData,
        creditMemoData: creditMemoData,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  clearCriteria = () => {
    let criteria = new CheckPaymentDetailsPaymentInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({ criteria: criteria });
    this.hideAlertCallBack();
  };
  resetInquiry = () => {
    let criteria = new CheckPaymentDetailsPaymentInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.customerName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
    });
    this.hideAlertCallBack();
  };
  generatePDF = () => {
    this.generateReport(1);
  };
  generateExcel = () => {
    this.generateReport(2);
  };
  generateReport = (reportType) => {
    let currentDate = new Date();
    currentDate = currentDate.toLocaleDateString("sv-SE");
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new CheckPaymentHistoryPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating Report...",
    });
    if (reportBean.reportType == 1) {
      if (
        SecurityAccessManager.CreditMemoPaymentHistoryInquiryPDFReport_IsAccessible()
      ) {
        ReportService.generateCheckPaymentHistoryPrintReport(
          listRequest,
          this.generateCreditMemoPaymentPageResponse,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(2);
      }
    } else if (reportBean.reportType == 2) {
      if (
        SecurityAccessManager.CreditMemoPaymentHistoryInquiryExcelReport_IsAccessible()
      ) {
        ReportService.generateCheckPaymentHistoryPrintReport(
          listRequest,
          this.generateCreditMemoPaymentPageResponseForExcel,
          this.errorCallBack
        );
      } else {
        this.inValidAccess(3);
      }
    }
  };
  generateCreditMemoPaymentPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
   generateCreditMemoPaymentPageResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
              window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewARModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowARModule: true,
          moduleForPopup: (
            <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowARModule: isOpen,
      moduleForPopup: [],
    });
  };
  onModuleExit = () => {
    this.props.onModuleExit();
  };
  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.showAutoCompleteCustomerList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.showAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCustomerList;
      let criteria = this.state.criteria;
      criteria.customerCode = "";
      criteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        criteria.customerName = customerData.description;
        criteria.customerCode = customerData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack
    );
  };

  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack
    );
  }
  readByCustomerCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCustomerList: showAutoCompleteList });
  };
  creditCodeOnChange = (e) => {
    let creditCode = e.target.value;
    this.state.showAutoCompleteCreditList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteCreditList;
    if (isEmpty(creditCode)) {
      this.state.showAutoCompleteCreditList = false;
      let showAutoCompleteList = this.state.showAutoCompleteCreditList;
      let criteria = this.state.criteria;
      criteria.creditMemoNumber = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        creditPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "creditMemoNumber" &&
      showAutoCompleteList === true &&
      creditCode !== ""
    ) {
      this.readCreditBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
    this.readCreditMemo(creditCode);
  };
  readCreditBySearchString(searchString) {
    let searchCriteria = new CreditMemoSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.creditMemoNumberStartsWith = searchString;
    searchCriteria.creditMemoNumberContains = searchString;
    let credit_pageList = new RestPageListBean();
    credit_pageList.pageSize = 100;
    let credit_requestInput = new RestCreditMemoBeanRequest();
    credit_requestInput.pageInput = credit_pageList;
    credit_requestInput.searchCriteria = searchCriteria;
    CreditMemoService.getCreditMemoPageList(
      credit_requestInput,
      this.readByCreditCodeResponse,
      this.errorCallBack
    );
  }
  readByCreditCodeResponse = (response) => {
    let creditData = response.data.creditMemoPageList.creditMemos;
    let simpleAutoCompleteList = new Array();
    if (creditData.length > 0 && creditData != null) {
      creditData.map((cr) => {
        let simpleItemBean = {
          code: cr.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      creditPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readCreditMemo = (cmNumber) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = cmNumber;
    readrestInput.isLockRequired = true;
    CreditMemoService.readCreditMemo(
      readrestInput,
      this.readCreditMemoResponse,
      this.errorCallBack
    );
  };
  readCreditMemoResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.creditMemo != null) {
      let creditData = response.data.creditMemo;
      if (!isEmpty(creditData)) {
        criteria.creditMemoNumber = creditData.code;
        this.setState({
          criteria: criteria,
        });
      }
    }
  };
  creditCodeEnterKeyEventHandler = (e) => {
    let creditCode = e.target.value;
    this.readCreditMemo(creditCode);
    this.setState({
      creditPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCreditList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteCreditList: showAutoCompleteList });
  };
  inquiryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("AR#", "accountReceivableNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewARModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customerPurchaseOrderNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenInvoiceAmt", "openInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAppliedAmt", "totalAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmt", "apppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CM Applied", "creditMemoAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;
  };
  creditAppliedColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("AR#", "accountReceivableNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewARModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "customcustomerPurchaseOrderNumbererCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvoiceDate", "invoiceDate", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice#", "invoiceNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.viewInvoiceModule, null)
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OpenInvoiceAmt", "openInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalInvoiceAmt", "totalInvoiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("AppliedAmt", "appliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("CM Applied", "creditMemoAppliedAmount", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3")
    );
    return columns;

  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let inquiryData = this.state.inquiryData;
    let creditMemoAppliedInvoiceList = this.state.creditMemoAppliedInvoiceList;
    let creditMemoData = this.state.creditMemoData;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={this.state.pageTitle}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowResetButton={this.state.isShowResetButton}
          isShowPDFButton={this.state.isShowPDFButton}
          isShowExcelButton={this.state.isShowExcelButton}
          isShowExitButton={this.state.isShowExitButton}
          onModuleExit={this.onModuleExit}
          execute={this.execute}
          clearCriteria={this.clearCriteria}
          clearError={this.clearError}
          reset={this.resetInquiry}
          generatePDF={this.generatePDF}
          generateExcel={this.generateExcel}
        />
        <CriteriaView
          {...this.state}
          loadPage={this.loadPage}
          onChange={this.onChange}
          customerLookupHandler={this.state.customerLookupHandler}
          openInvoiceReport={this.openInvoiceReport}
          customerCodeOnChange={this.customerCodeOnChange}
          customerCodeRef={this.customerCodeRef}
          customerCodeEnterKeyEventHandler={
            this.customerCodeEnterKeyEventHandler
          }
          displayAutoCompleteList={this.displayAutoCompleteList}
          creditCodeEnterKeyEventHandler={this.creditCodeEnterKeyEventHandler}
          displayAutoCompleteCreditList={this.displayAutoCompleteCreditList}
          creditCodeOnChange={this.creditCodeOnChange}
        />
        {this.state.isInquiryDatasFound && (
          <div>
            <Row>
              <Col sm="1">
                {" "}
                <FormLabel>AR#</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={inquiryData.accountReceivableNumber}
                  className="summary_input"
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>AppliedAmount</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <NumberFormatInputbox
                  value={inquiryData.creditMemoAppliedAmount}
                  className="summary_input text-right"
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                {" "}
                <FormLabel>OverPaid CM</FormLabel>
              </Col>
              <Col className="summary_text_box" sm="2">
                <InputTextbox
                  value={inquiryData.overPaymentCreditMemoNumber}
                  className="summary_input"
                  disabled={true}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                {creditMemoData != null && (
                  <div className="header_div col-md-12 col-lg-12">
                    <FormLabel>OverPaid CreditMemo Details</FormLabel>
                    <br />
                    <Row className="d-flex justify-content-left">
                      <Col sm="1">
                        <FormLabel>CreditMemo#</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={creditMemoData.creditMemoNumber}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>Status</FormLabel>
                      </Col>
                      <Col sm="2">
                        <InputTextbox
                          value={creditMemoData.status}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>Amount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={creditMemoData.amount}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                      <Col sm="1">
                        {" "}
                        <FormLabel>Applied Amount</FormLabel>
                      </Col>
                      <Col sm="2">
                        <NumberFormatInputbox
                          value={creditMemoData.appliedAmount}
                          decimalScale={2}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                )}
              </Col>
            </Row>
            <Row>
              <Col sm="6">
                <FormLabel> CreditMemo Applied Invoice Details</FormLabel>
              </Col>
              <Col sm="6">
                <FormLabel> CreditMemo Applied Invoice Details</FormLabel>
              </Col>
            </Row>
            <div className="div_inline">
              <div className="div_Equal_no_overflow">
                <div className="mt-3">
                  <CustomTable
                    data={inquiryDataList}
                    columns={this.inquiryColumns()}
                  />
                </div>
              </div>
              <div className="div_Equal_no_overflow">
                <div className="mt-3">
                  <CustomTable
                    data={creditMemoAppliedInvoiceList}
                    columns={this.creditAppliedColumns()}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
      </div>
    );
  }
}
export function CriteriaView(props) {
  const [show, setShow] = useState(false);
  const handleButton = () => setShow(!show);
  const onChange = (e) => props.onChange(e);
  const loadPage = () => {
    handleButton();
    props.loadPage(1);
  };
  const customerCodeOnChange = (e) => props.customerCodeOnChange(e);
  const creditCodeOnChange = (e) => props.creditCodeOnChange(e);
  let criteria = props.criteria;
  let customerLookupHandler = props.customerLookupHandler;
  let creditMemoLookupHandler = props.creditMemoLookupHandler;
  let customerCodeRef = props.customerCodeRef;
  let isInquiryDatasFound = props.isInquiryDatasFound;
  let inquiryData = props.inquiryData;
  const customerCodeEnterKeyEventHandler = (e) => {
    props.customerCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteList = () => {
    props.displayAutoCompleteList();
  };
  const creditCodeEnterKeyEventHandler = (e) => {
    props.creditCodeEnterKeyEventHandler(e);
  };
  const displayAutoCompleteCreditList = () => {
    props.displayAutoCompleteCreditList();
  };
  return (
    <div>
      {isInquiryDatasFound == false && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>CustomerCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              ref={customerCodeRef}
              name="customerCode"
              onChange={customerCodeOnChange}
              value={criteria.customerCode}
              lookupRequired={true}
              lookupHandler={customerLookupHandler}
              showCriteriaDialog={true}
              enterKeyEventHandler={customerCodeEnterKeyEventHandler}
              autoCompleteListData={props.customerPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteList}
              showAutoCompleteList={props.showAutoCompleteCustomerList}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              name="customerName"
              onChange={onChange}
              value={criteria.customerName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>CreditMemo</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              name="creditMemoNumber"
              onChange={creditCodeOnChange}
              value={criteria.creditMemoNumber}
              lookupRequired={true}
              lookupHandler={creditMemoLookupHandler}
              enterKeyEventHandler={creditCodeEnterKeyEventHandler}
              autoCompleteListData={props.creditPageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteCreditList}
              showAutoCompleteList={props.showAutoCompleteCreditList}
              disabled={props.isDisableFields}
              isMandatory={true}
            />
          </Col>
        </Row>
      )}
      {isInquiryDatasFound == true && (
        <Row className="d-flex justify-content-left">
          <Col sm="1">
            {" "}
            <FormLabel>CustomerCode</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onChange}
              value={inquiryData.customerCode}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onChange}
              value={inquiryData.customerName}
              disabled={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>CreditMemo</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onChange}
              value={inquiryData.creditMemoNumber}
              disabled={true}
            />
          </Col>
          <Col sm="2">
            <FormLabel>CreditMemo Amt</FormLabel>
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onChange}
              value={inquiryData.creditMemoAmount}
              disabled={true}
            />
          </Col>
        </Row>
      )}
    </div>
  );
}
function CreditMemoPaymentHistoryInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CreditMemoPaymentHistory {...props} name="" /> <br />
    </div>
  );
}

export default CreditMemoPaymentHistoryInquiry;
